import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";

import Index from "../views";
import EventManage from '../views/eventManage'
import AddEvent from '../views/addEvent'
import AddForm from '../views/addForm'
import NoticeManage from '../views/noticeManage'
import AdsManage from '../views/adsManage'
import noticeManage from '../views/noticeManage'
import AllEvent from '../views/allEvent'
import Login from '../views/login'
import FormResultManage from '../views/formResultManage'
import RegistrationAddonManage from '../views/registrationAddonManage'
import RegistrationDailyDashboard from '../views/registrationDashboard'
import RegistrationMonthlyDashboard from '../views/registrationMonthlyDashboard'
import RegistrationMapDashboard from '../views/registrationMapDashboard'
import RegistrationBrandDashboard from '../views/registrationBrandDashboard'
import EquipmentManage from '../views/equipmentManage'
import AddArticle from '../views/addArticle'
import ArticleManage from '../views/articleManage'
import ImageUpload from '../views/imageUpload'
import CouponCodeManage from '../views/couponCodeManage'
import LiveEventManage from '../views/liveEventManage'
import ObsOverlayManage from '../views/obsOverlay'
import RoleManage from '../views/roleManage'
import UserManage from '../views/userManage'
import OperationLog from '../views/operationLog'
import Forbidden from '../views/forbidden'
import { getToken, hasPermission, updateAuthProfile, clearAuth } from '../utils/auth'

Vue.use(VueRouter);

const dashboardHomeCandidates = [
  { path: "/registration-dashboard/daily", permission: "dashboard:daily:view" },
  { path: "/registration-dashboard/monthly", permission: "dashboard:monthly:view" },
  { path: "/registration-dashboard/map", permission: "dashboard:map:view" },
  { path: "/registration-dashboard/brand", permission: "dashboard:brand:view" },
];

const fallbackHomeCandidates = [
  ...dashboardHomeCandidates,
  { path: "/manage", permission: "event:view" },
  { path: "/form_result", permission: "registration:view" },
  { path: "/registration-addons", permission: "registration:addon:view" },
  { path: "/coupon-code", permission: "coupon:view" },
  { path: "/notice", permission: "content:notice" },
  { path: "/ads", permission: "content:ads" },
  { path: "/live-event", permission: "content:live" },
  { path: "/obs-overlay", permission: "content:obsOverlay" },
  { path: "/equipment", permission: "content:equipment" },
  { path: "/article-list", permission: "content:article" },
  { path: "/image-upload", permission: "upload:image" },
  { path: "/users", permission: "system:user:view" },
  { path: "/roles", permission: "system:role:view" },
  { path: "/operation-logs", permission: "*" },
];

const getFirstPermittedPath = (candidates) => {
  const target = candidates.find(item => !item.permission || hasPermission(item.permission));
  return target ? target.path : "/403";
};

const getDefaultHomePath = () => getFirstPermittedPath(fallbackHomeCandidates);

const getDashboardHomePath = () => getFirstPermittedPath(dashboardHomeCandidates);

let refreshingAuthProfile = null;

const refreshAuthProfile = () => {
  const token = getToken();
  if (!token) return Promise.resolve();
  if (!refreshingAuthProfile) {
    refreshingAuthProfile = axios.get('/users/me', {
      headers: {
        'x-auth-token': token
      }
    }).then((res) => {
      const user = res.data && res.data.res ? res.data.res : {};
      updateAuthProfile(user, user.permissions || []);
    }).catch((err) => {
      const code = err.response && err.response.data && err.response.data.code;
      if (code === 'token_timeout' || code === 'no_auth' || code === 'USER_DISABLED') {
        clearAuth();
      }
      throw err;
    }).finally(() => {
      refreshingAuthProfile = null;
    });
  }
  return refreshingAuthProfile;
};

const routes = [
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "/",
        redirect: getDefaultHomePath,
      },
      {
        path: "/manage",
        component: EventManage,
        meta: { title: "赛事列表", permission: "event:view" },
      },
      {
        path: "/add",
        component: AddEvent,
        meta: { title: "新增赛事", permission: "event:create" },
      },
      {
        path: "/add-form",
        component: AddForm,
        meta: { title: "添加报名表单", permission: "registrationForm:create" },
      },
      {
        path: "/notice",
        component: NoticeManage,
        meta: { title: "通知管理", permission: "content:notice" },
      },
      {
        path: "/ads",
        component: AdsManage,
        meta: { title: "推荐位管理", permission: "content:ads" },
      },
      {
        path: "/notice",
        component: noticeManage,
        meta: { title: "通知管理", permission: "content:notice" },
      },
      {
        path: "/database",
        component: AllEvent,
        meta: { title: "历史赛事数据库", permission: "event:view" },
      },
      {
        path: "/form_result",
        component: FormResultManage,
        meta: { title: "报名名单管理", permission: "registration:view" },
      },
      {
        path: "/registration-addons",
        component: RegistrationAddonManage,
        meta: { title: "兼项管理", permission: "registration:addon:view" },
      },
      {
        path: "/registration-dashboard",
        redirect: getDashboardHomePath,
      },
      {
        path: "/registration-dashboard/daily",
        component: RegistrationDailyDashboard,
        meta: { title: "报名数据大盘", permission: "dashboard:daily:view" },
      },
      {
        path: "/registration-dashboard/monthly",
        component: RegistrationMonthlyDashboard,
        meta: { title: "月数据大盘", permission: "dashboard:monthly:view" },
      },
      {
        path: "/registration-dashboard/map",
        component: RegistrationMapDashboard,
        meta: { title: "地图大盘", permission: "dashboard:map:view" },
      },
      {
        path: "/registration-dashboard/brand",
        component: RegistrationBrandDashboard,
        meta: { title: "品牌数据大盘", permission: "dashboard:brand:view" },
      },
      {
        path: "/coupon-code",
        component: CouponCodeManage,
        meta: { title: "优惠码管理", permission: "coupon:view" },
      },
      {
        path: "/live-event",
        component: LiveEventManage,
        meta: { title: "直播管理", permission: "content:live" },
      },
      {
        path: "/obs-overlay",
        component: ObsOverlayManage,
        meta: { title: "OBS 直播画面", permission: "content:obsOverlay" },
      },
      {
        path: "/equipment",
        component: EquipmentManage,
        meta: { title: "商品管理", permission: "content:equipment" },
      },
      {
        path: "/add-article",
        component: AddArticle,
        meta: { title: "添加文章", permission: "content:article" },
      },
      {
        path: "/article-list",
        component: ArticleManage,
        meta: { title: "文章列表", permission: "content:article" },
      },
      {
        path: "/image-upload",
        component: ImageUpload,
        meta: { title: "图片上传", permission: "upload:image" },
      },
      {
        path: "/users",
        component: UserManage,
        meta: { title: "用户管理", permission: "system:user:view" },
      },
      {
        path: "/roles",
        component: RoleManage,
        meta: { title: "角色管理", permission: "system:role:view" },
      },
      {
        path: "/operation-logs",
        component: OperationLog,
        meta: { title: "操作日志", permission: "*" },
      },
      {
        path: "/403",
        component: Forbidden,
        meta: { title: "无权限访问" },
      },
    ],
  },
  {
    path: "/login",
    name: 'Login',
    component: Login,
  },
];
const router = new VueRouter({
  routes,
});

import { Notification } from 'element-ui';
Vue.prototype.$notification = Notification;

// 挂载全局路由导航守卫
router.beforeEach(async (to,from,next) => {
  // to：将要访问的路径
  // from：从哪个路径跳转而来
  // next：是一个函数，表示放行
  const token = getToken()
  if(token){
    try {
      await refreshAuthProfile();
    } catch (err) {
      next('/login');
      return;
    }
    if (to.path === '/login') {
      next(getDefaultHomePath());
      return;
    }
    const permission = to.meta && to.meta.permission;
    if (permission && !hasPermission(permission)) {
      next('/403');
      return;
    }
    next();
  } else {
    if(to.path === '/login'){ 
      //如果是登录页面,就停留登录页
      next();
    } else { 
      //不然就跳转到登录
      Notification({
        title: '您还未登录',
        message: '请登录！',
        type: 'warning'
      });
      next('/login');
    }
  }
});

export default router;
